export default "__VITE_ASSET__mvVEWrTX__"